import { useDeleteAssignedLessons } from "hooks/userContextMenu/useDeleteAssignedLessons";
import { useDeleteAssignedUsers } from "hooks/userContextMenu/useDeleteAssignedUsers";
import { useDeleteUser } from "hooks/userContextMenu/useDeleteUser"

export const useUserActions = () => {
    const { deleteUser, deletingUser } = useDeleteUser();
    const { deleteAssignedLessons, deletingAssignedLessons } = useDeleteAssignedLessons();
    const { deleteAssignedUsers, deletingAssignedUsers } = useDeleteAssignedUsers();

    return { deleteUser, deletingUser, deleteAssignedLessons, deletingAssignedLessons, deleteAssignedUsers, deletingAssignedUsers };
}